import { InvoiceDocumentType } from '@features/invoices/enums/invoiceDocumentType'
import { ResolvedZervantDocument } from '@features/zervantDocuments/types/resolvedZervantDocument'

import { reactRoute } from '../../../../../utils/routing/reactRoute'

export const getZervantDocumentTargetRoute = (document: ResolvedZervantDocument): string => {
  const id = String(document.id)

  switch (document.documentType) {
    case 'creditNote':
      return reactRoute.organization.invoices.getViewInvoiceRoute(id, InvoiceDocumentType.CreditNote)
    case 'importedInvoice':
      return `${reactRoute.organization.importedInvoices.getMainRoute()}?importedInvoiceId=${id}`
    case 'invoice':
      return reactRoute.organization.invoices.getViewInvoiceRoute(id, InvoiceDocumentType.Invoice)
  }
}
